<script>
  export let weeks;
  export let selectedWeek;
  export let onChangeSelectedWeek;


  const onClickDropdown = () => {
    isSelecting = !isSelecting;
  };
  const onSelectWeek = (week) => {
    isSelecting = false;
    onChangeSelectedWeek({...week})
  };


  $: isSelecting = false;

</script>

<div
    on:click={onClickDropdown}
    class="dropdown_button {isSelecting ? 'is_selecting' : ''}"
  >
    <p class="select_text">
      {selectedWeek != "" && isSelecting == false
        ? `${selectedWeek.weekName}`
        : "SELECT WEEK"}
    </p>
    <img src="/images/chevron.png" alt="" class="chev" />
  </div>
  
  
  
  
  
  {#if isSelecting}
    {#each weeks as week}
      <div class="dropdown_button" on:click={() => onSelectWeek(week)}>
        <p class="select_text">
          {week.weekName}
        </p>
      </div>
    {/each}
  {/if}


  <style>
        .dropdown_button {
    color: white;
    font-family: "Courier New", Courier, monospace;
    border: 1px solid white;
    height: 45px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
  }

  .chev {
    width: 13px;
  }

  .select_text {
    padding-top: 17px;
    opacity: 0.7;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .is_selecting {
    color: black !important;
    background-color: white;
  }

  .is_selecting > p {
    color: black !important;
    opacity: 1;
  }

  .is_selecting > img {
    filter: invert(100);
  }
</style>